var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-470 -397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.962,9.174a2.712,2.712,0,1,1,2.712-2.712A2.715,2.715,0,0,1,10.962,9.174Zm0-4.339a1.627,1.627,0,1,0,1.627,1.627A1.629,1.629,0,0,0,10.962,4.835Z",
    transform: "translate(468.462 397.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.923,15a.809.809,0,0,1-.481-.158.826.826,0,0,1-.176-.176C4.964,8.741,4.5,6.229,4.5,5.424a5.424,5.424,0,1,1,10.848,0c0,2.484-3.647,7.7-4.765,9.24a.809.809,0,0,1-.535.325A.724.724,0,0,1,9.923,15Zm0-13.915A4.345,4.345,0,0,0,5.585,5.424c0,1.657,2.288,5.434,4.339,8.3,2.05-2.865,4.339-6.642,4.339-8.3A4.345,4.345,0,0,0,9.924,1.085Z",
    transform: "translate(469.5 398.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H18V18H0Z",
    transform: "translate(470 397)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin-location.880b53b3.svg";
export { ForwardRef as ReactComponent };